<template>
  <div class="flex flex-col h-full">
    <DashboardHeader title="Add Referrer" link="/referrers/add-referrer"> </DashboardHeader>

    <div
      class="flex w-full flex-1 overflow-y-auto border-[1px] border-gray-200 rounded-xl bg-white"
    >
      <ReferrerAddForm />
    </div>
  </div>
</template>

<script setup lang="ts">
import DashboardHeader from '@/components/common/DashboardHeader.vue'
import ReferrerAddForm from '@/components/referrers/ReferrerAddForm.vue'
</script>
